import { useState } from "react";
import { api } from "../api";
import Card from "./ui/Card";
import Input from "./ui/Input";
import Btn from "./ui/Btn";
import Modal from "./ui/Modal";
import Select from "./ui/Select";

export default function StationsMgmt({
  stations,
  assignments,
  toast,
  refresh,
  user,
}) {
  const isReadOnly = user?.role === "auditor";
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({
    name: "",
    code: "",
    region: "",
    project: "",
    active: true,
  });
  const [search, setSearch] = useState("");
  const filtered = stations.filter(
    (s) =>
      !search ||
      s.name.includes(search) ||
      s.region.includes(search) ||
      (s.code || "").includes(search)
  );
  const assignedIds = new Set(assignments.map((a) => a.station_id));

  const save = async () => {
    if (!form.name || !form.region) {
      toast("الاسم والمنطقة مطلوبان", "warning");
      return;
    }
    try {
      if (modal === "add")
        await api("/stations", {
          method: "POST",
          body: { ...form, project: form.project || form.region },
        });
      else await api(`/stations/${form.id}`, { method: "PUT", body: form });
      toast("✅ تم الحفظ");
      setModal(null);
      refresh();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  const del = async (s) => {
    if (assignedIds.has(s.id)) {
      toast("لا يمكن حذف محطة معينة — أزل التعيين أولاً", "warning");
      return;
    }
    if (!window.confirm(`حذف محطة "${s.name}"؟`)) return;
    try {
      await api(`/stations/${s.id}`, { method: "DELETE" });
      toast("🗑️ تم الحذف");
      refresh();
    } catch (e) {
      toast("خطأ: " + e.message, "error");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <h2
          style={{
            fontSize: 20,
            fontWeight: 800,
            margin: 0,
            color: "#f1f5f9",
          }}
        >
          🏭 المحطات ({filtered.length})
        </h2>
        <div style={{ display: "flex", gap: 8 }}>
          <input
            placeholder="🔍 بحث..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              background: "#1e293b",
              border: "1px solid #334155",
              borderRadius: 8,
              padding: "7px 12px",
              color: "#f1f5f9",
              fontSize: 12,
              fontFamily: "inherit",
              width: 180,
            }}
          />
          {!isReadOnly && (
            <Btn
              onClick={() => {
                setForm({
                  name: "",
                  code: "",
                  region: "",
                  project: "",
                  active: true,
                });
                setModal("add");
              }}
              color="#22c55e"
            >
              + إضافة
            </Btn>
          )}
        </div>
      </div>
      <Card>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 12,
            }}
          >
            <thead>
              <tr style={{ background: "#0f172a" }}>
                {["#", "المحطة", "الكود", "المنطقة", "الحالة", "معينة", "⚙️"].map(
                  (h) => (
                    <th
                      key={h}
                      style={{
                        padding: "8px 10px",
                        color: "#64748b",
                        textAlign: "right",
                        borderBottom: "1px solid #1e293b",
                      }}
                    >
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {filtered.map((s, i) => (
                <tr
                  key={s.id}
                  style={{
                    borderBottom: "1px solid #0f172a",
                    background: i % 2 ? "#ffffff03" : "transparent",
                  }}
                >
                  <td style={{ padding: "7px 10px", color: "#475569" }}>
                    {i + 1}
                  </td>
                  <td
                    style={{
                      padding: "7px 10px",
                      color: "#f1f5f9",
                      fontWeight: 600,
                    }}
                  >
                    {s.name}
                  </td>
                  <td style={{ padding: "7px 10px", color: "#38bdf8", fontFamily: "monospace" }}>
                    {s.code || "—"}
                  </td>
                  <td style={{ padding: "7px 10px", color: "#94a3b8" }}>
                    {s.region}
                  </td>
                  <td style={{ padding: "7px 10px" }}>
                    <span
                      style={{
                        background: s.active ? "#052e16" : "#1c0303",
                        color: s.active ? "#22c55e" : "#ef4444",
                        borderRadius: 5,
                        padding: "2px 7px",
                        fontSize: 10,
                      }}
                    >
                      {s.active ? "نشطة" : "موقوفة"}
                    </span>
                  </td>
                  <td style={{ padding: "7px 10px" }}>
                    <span
                      style={{
                        background: assignedIds.has(s.id)
                          ? "#052e16"
                          : "#1c1003",
                        color: assignedIds.has(s.id)
                          ? "#22c55e"
                          : "#f59e0b",
                        borderRadius: 5,
                        padding: "2px 7px",
                        fontSize: 10,
                      }}
                    >
                      {assignedIds.has(s.id) ? "معينة" : "غير معينة"}
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "7px 10px",
                      display: "flex",
                      gap: 5,
                    }}
                  >
                    {!isReadOnly && (
                      <>
                        <Btn
                          size="sm"
                          color="#38bdf8"
                          onClick={() => {
                            setForm({ ...s });
                            setModal("edit");
                          }}
                        >
                          تعديل
                        </Btn>
                        {!assignedIds.has(s.id) && (
                          <Btn
                            size="sm"
                            color="#ef4444"
                            onClick={() => del(s)}
                          >
                            حذف
                          </Btn>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
      {modal && (
        <Modal
          title={modal === "add" ? "إضافة محطة" : "تعديل محطة"}
          onClose={() => setModal(null)}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <Input
              label="اسم المحطة"
              value={form.name}
              onChange={(v) => setForm((f) => ({ ...f, name: v }))}
              required
            />
            <Input
              label="كود المحطة"
              value={form.code || ""}
              onChange={(v) => setForm((f) => ({ ...f, code: v }))}
              placeholder="مثال: 02-01-024"
            />
            <Input
              label="المنطقة"
              value={form.region}
              onChange={(v) => setForm((f) => ({ ...f, region: v }))}
              required
            />
            <Input
              label="المشروع"
              value={form.project || ""}
              onChange={(v) => setForm((f) => ({ ...f, project: v }))}
            />
            {modal === "edit" && (
              <Select
                label="الحالة"
                value={form.active ? "1" : "0"}
                onChange={(v) => setForm((f) => ({ ...f, active: v === "1" }))}
                options={[
                  { value: "1", label: "نشطة" },
                  { value: "0", label: "موقوفة" },
                ]}
              />
            )}
            <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
              <Btn onClick={save} color="#22c55e" size="lg">
                💾 حفظ
              </Btn>
              <Btn onClick={() => setModal(null)} color="#64748b" size="lg">
                إلغاء
              </Btn>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
